interface WorsaasLogomarkProps {
  size?: number;
  variant?: 'color' | 'white';
  className?: string;
}

export function WorsaasLogomark({
  size = 32,
  variant = 'color',
  className,
}: WorsaasLogomarkProps) {
  const primary = variant === 'color' ? '#4f46e5' : '#ffffff';
  const accent = variant === 'color' ? '#7c3aed' : 'rgba(255,255,255,0.85)';
  const secondary = variant === 'color' ? primary : 'rgba(255,255,255,0.7)';

  return (
    <svg
      viewBox="36 43 120 120"
      width={size}
      height={size}
      className={className}
      aria-hidden="true"
    >
      {/* Central hub node */}
      <circle cx="80" cy="100" r="22" fill={primary} />
      {/* Satellite nodes */}
      <circle cx="130" cy="62" r="10" fill={primary} />
      <circle cx="140" cy="115" r="8" fill={accent} />
      <circle cx="115" cy="148" r="6" fill={secondary} opacity="0.7" />
      {/* Connection lines */}
      <line x1="98" y1="88" x2="122" y2="68" stroke={primary} strokeWidth="3.5" strokeLinecap="round" />
      <line x1="100" y1="106" x2="133" y2="113" stroke={accent} strokeWidth="3" strokeLinecap="round" />
      <line x1="92" y1="118" x2="111" y2="143" stroke={secondary} strokeWidth="2.5" strokeLinecap="round" opacity="0.7" />
      {/* Signal arcs */}
      <path d="M 56 78 A 32 32 0 0 1 56 122" fill="none" stroke={primary} strokeWidth="3" strokeLinecap="round" opacity="0.35" />
      <path d="M 46 68 A 44 44 0 0 1 46 132" fill="none" stroke={primary} strokeWidth="2.5" strokeLinecap="round" opacity="0.2" />
    </svg>
  );
}

interface WorsaasLogoProps {
  size?: number;
  variant?: 'color' | 'white';
  className?: string;
  showWordmark?: boolean;
}

export function WorsaasLogo({
  size = 32,
  variant = 'color',
  className,
  showWordmark = true,
}: WorsaasLogoProps) {
  const textColor = variant === 'color' ? 'text-slate-900 dark:text-white' : 'text-white';

  return (
    <div className={`flex items-center gap-2 ${className ?? ''}`}>
      <WorsaasLogomark size={size} variant={variant} />
      {showWordmark && (
        <span
          className={`text-lg font-semibold tracking-tight ${textColor}`}
          style={{ letterSpacing: '-0.5px' }}
        >
          WorSaaS
        </span>
      )}
    </div>
  );
}
